import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { sectionBoxSx, labelValueRowSx, labelSx, valueSx } from './info.styles';

interface LineageInfoProps {
  sourceLabel: string;
  targetLabel: string;
}

export const LineageInfo: React.FC<LineageInfoProps> = ({
  sourceLabel,
  targetLabel,
}) => {
  return (
    <Box>
      <Box sx={sectionBoxSx}>
        <Box sx={labelValueRowSx}>
          <Typography sx={labelSx}>Source</Typography>
          <Typography sx={valueSx}>{sourceLabel}</Typography>
        </Box>
        <Box sx={labelValueRowSx}>
          <Typography sx={labelSx}>Target</Typography>
          <Typography sx={valueSx}>{targetLabel}</Typography>
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{ mt: 1.5, color: 'text.secondary', fontStyle: 'italic' }}
      >
        This material contributes to the merged state after a transfer.
      </Typography>
    </Box>
  );
};
